<template>
  <div>
  <modal name="modal-success"
  @before-open="beforeOpen"
  height="100%"
  width="100%"
  :clickToClose="false"
  class="modal-page-success pagesuccess"
  :adaptive="true">
    <div class="merchant success">
      <div class="cashalo-div">
        <img src="@/assets/cashalo.svg" alt="">
      </div>
      <div class="waves"></div>
      <div class="circle-right"></div>
        <div class="success-div">
          <div class="ui grid container success">
            <div v-if="success" class="content">
              <h4>Thank you for your submission!</h4>
              <p>We will contact you as soon as we can.</p>
            </div>

            <div v-if="!success" class="content">
              <h4>Oops There's an Error!</h4>
              <p>There was an error in submitting your form
                <br>please try again </p>
            </div>
            <a class="ui orange button" @click="close">OK</a>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>

export default {
  name:'modal-success',
  data() {
    return {
      success: '',
    }
  },
  methods: {
    close() {
      location.reload()
    },

    beforeOpen(event) {
      this.success = event.params
    },
  },
  mounted() {

  }
}
</script>
